import { REQUEST_M} from '../../const';

export default function UserReducer(state = [], action) {
  switch (action.type) {
      case REQUEST_M:
      return action.m_list;
    default:
      return state;
  }
}